import s from '../allservices.jsx'
import {
    Link, withRouter
} from 'react-router-dom';

const getProfielService = actionCallback => {
    const memberId = localStorage.getItem("memberId")
    let token = "Token " + localStorage.getItem('token')
    fetch(s.get_profile + "/" + memberId + "/?Authorization=" + token, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else if (res.status === 401) {
               
                // localStorage.clear();
                //  this.props.history.push("/")
                let errorOut= "logout"
                actionCallback(errorOut)
            
               
            }
            else {
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getProfielService;


// WEBPACK FOOTER //
// ./src/services/components/get_profile.jsx